function getBookingWidgetDataFromObject(data, ctx) {

  const widgetData = {
    set: true,
  };

  // ID
  widgetData.bookingId = data.booking_id;

  if (!widgetData.bookingId) {
    widgetData.set = false;
  }

  // Dates
  widgetData.dateBegin = (data.checkin_date || '').replace(/-/g, '/');
  widgetData.dateEnd = (data.checkout_date || '').replace(/-/g, '/');

  // Currency
  widgetData.currency = ctx.thn.getCurrencyCode(data.currency_code);

  // Price
  widgetData.price = parseFloat(data.booking_total) + parseFloat(data.total_tax);

  // PromoCode
  if (data.resRooms && data.resRooms[0] && data.resRooms[0].package_name) {
    widgetData.promocode = data.resRooms[0].package_name;
  }

  return widgetData;
}

export { getBookingWidgetDataFromObject as g };
